let pendingRequests = 0;
let suppressed = false;
const listeners = new Set();

function notify() {
  const isLoading = pendingRequests > 0 && !suppressed;
  listeners.forEach((listener) => {
    try {
      listener(isLoading);
    } catch {
      // Ignore subscriber errors so loader state keeps updating.
    }
  });
}

export function beginGlobalNetworkRequest() {
  pendingRequests += 1;
  notify();
}

export function endGlobalNetworkRequest() {
  pendingRequests = Math.max(0, pendingRequests - 1);
  notify();
}

export function subscribeGlobalNetworkLoader(listener) {
  listeners.add(listener);
  listener(pendingRequests > 0 && !suppressed);
  return () => listeners.delete(listener);
}

export function setGlobalNetworkLoaderSuppressed(nextSuppressed) {
  suppressed = !!nextSuppressed;
  notify();
}
